import { router } from "@inertiajs/react";

interface ErrorProps {
  status: number;
  message: string;
}

const descriptions: Record<number, string> = {
  404: "Houston, we have a problem. This page never made it to the launchpad.",
  500: "Something went wrong on our end. The rocket scientists are looking into it.",
};

export default function Error({ status, message }: ErrorProps) {
  return (
    <div className="flex items-center justify-center min-h-[60vh]">
      <div className="max-w-sm text-center">
        <div className="text-7xl font-black text-foreground">{status}</div>
        <div className="w-16 h-1 bg-primary mx-auto my-6" />
        <p className="text-xl text-muted-foreground mb-8">
          {descriptions[status] || message}
        </p>
        <button
          onClick={() => router.visit("/")}
          className="btn btn-primary"
        >
          Back to home
        </button>
      </div>
    </div>
  );
}
